// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_8E3Vq3JmzY3PWGvmUoau4qWrc3sG" as const;
export const builtAt = "2026-11-05T04:38:05.170Z" as const;
export const vercelEnv: string | null = "preview";
export const gitCommitSha: string | null = "4e8832e122f64b90c8eaa9ff91453e33dc5d0e3f";
export const deploymentId: string | null = "dpl_8E3Vq3JmzY3PWGvmUoau4qWrc3sG";
